import { render, staticRenderFns } from "./UpcomingCourses.vue?vue&type=template&id=45e25126&scoped=true&"
import script from "./UpcomingCourses.vue?vue&type=script&lang=js&"
export * from "./UpcomingCourses.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingCourses.vue?vue&type=style&index=0&id=45e25126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e25126",
  null
  
)

export default component.exports